<template>
    <div class="formula" v-html="formula" ref="jax" />
</template>

<script>
    export default {
        name: 'Formula',
        props: {
            formula: String
        },
        mounted(){
            window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, this.$refs.jax.$el]);
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .formula
    {
        margin: 30px 0;
        color: var(--primary-text-color);
        font-size: 1.25rem;
        text-align: center;
    }
</style>
